import { post } from './httpHelpers'
import { SuccessResponse } from '../types'

export const postWaitlistMember = (email: string) =>
  post<SuccessResponse>('waitlist/members', { email }).then(
    (response) => response.parsedBody!['success']
  )
